import React, { useState, useEffect } from "react";
import "./Babaji.scss";
import firstimage from "../../assets/images/babaji1.jpg"
import secondimage from "../../assets/images/babaji2.jpg"
import img1 from "../../assets/babajiImages/b1.png"
import img2 from "../../assets/babajiImages/b2.png"
import img3 from "../../assets/babajiImages/b3.png"
import img4 from "../../assets/babajiImages/b4.png"
import img5 from "../../assets/babajiImages/b5.jpg"
import img6 from "../../assets/babajiImages/b6.jpeg"
import img7 from "../../assets/babajiImages/b7.jpg"
import img8 from "../../assets/babajiImages/b8.jpg"
import img9 from "../../assets/babajiImages/b9.jpg"
import petalImage from "../../assets/images/rosepetal.png"

export default function FamousPersonality() {
    const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
    const [startIndex, setStartIndex] = useState(0);
    const [isSliding, setIsSliding] = useState(false);
    const [mobilestartIndex, mobilesetStartIndex] = useState(0);
    const [mobileisSliding, mobilesetIsSliding] = useState(false);

    // Function to go to the next slide
    const nextSlide = () => {
        setIsSliding(true);
        setTimeout(() => {
            setStartIndex((prevIndex) => (prevIndex + 3 < images.length ? prevIndex + 3 : 0));
            setIsSliding(false);
        }, 500);
    };
    

    // Function to go to the previous slide
    const prevSlide = () => {
        setIsSliding(true);
        setTimeout(() => {
            setStartIndex((prevIndex) => (prevIndex - 4 >= 0 ? prevIndex - 4 : images.length - 4));
            setIsSliding(false);
        }, 500);
    };
    const mobilenextSlide = () => {
        mobilesetIsSliding(true);
        setTimeout(() => {
            mobilesetStartIndex((prevIndex) => (prevIndex + 1 < images.length ? prevIndex + 1 : 0));
            mobilesetIsSliding(false);
        }, 500);
    };
    const mobileprevSlide = () => {
        mobilesetIsSliding(true);
        setTimeout(() => {
            mobilesetStartIndex((prevIndex) => (prevIndex - 2 >= 0 ? prevIndex - 2 : images.length - 2));
            mobilesetIsSliding(false);
        }, 500);
    };

    // Auto-slide every 5 seconds
    useEffect(() => {
        const interval = setInterval(nextSlide, 5000);
        return () => clearInterval(interval);
    }, [startIndex]);  // Restart interval when `startIndex` changes

    useEffect(() => {
        const createPetal = () => {
            const petal = document.createElement("img");
            petal.src = petalImage;
            petal.classList.add("petal");
            document.body.appendChild(petal);

            const left = Math.random() * window.innerWidth; // Random X position
            const duration = Math.random() * 1 + 3; // 3 to 8 seconds
            const size = Math.random() * 20 + 20; // 20px to 40px

            petal.style.left = `${left}px`;
            petal.style.width = `${size}px`;
            petal.style.height = `${size}px`;
            petal.style.animationDuration = `${duration}s`;

            // Remove petal after animation
            setTimeout(() => {
                petal.remove();
            }, duration * 1000);
        };

        // Generate petals at intervals
        const interval = setInterval(createPetal, 150);

        // Stop shower after 10 seconds
        setTimeout(() => {
            clearInterval(interval);
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <div className="container">
                {/* Hero Section */}
                <section className="firstsection">
                    <div className="card1text">
                        <div className="subtext">
                            <h1>बाबाजी...</h1>
                            <p>श्री सद्गुरू अप्पामहाराज व‬ श्री दत्त मंदिर संस्थान रुईभर

                                श्री सद्गुरू अप्पामहाराज उर्फ श्री दत्तमहाराज रुईकर, मु. पो. रुईभर, ता. धाराशिव, जि. उस्मानाबाद येथिल दत्तमंदिरात त्यांचे वास्तव्य असते. दत्त उपासना मार्गातील एक उपासना असुन व्यक्तीमत्व असुन त्यांची राहणी अतिशय साधी आहे. समाजातील सर्वसामान्य माणसाची काळजी वाहण्याचे व त्यांचे जीवन सुखी, सुसह्य व सार्थकी करण्यासाठी त्यांनी आपले स्वतःचे जीवन समर्पित केले आहे. अहोरात्र जनसामान्याच्या सुखासाठी, त्यांच्या समस्या सोडविण्यसाठी ते सतत प्रयत्नशिल असतात. अंधश्रद्धेवर त्यंचा विश्वास नाही. समाजात रूढ असलेल्या रूढी, परंपरा, मान्यता प्रथम विज्ञानाच्या नंतर धर्माच्या आणि सर्वात महत्त्वाच्या म्हणजे समाजाच्या कसोटीवर सत्य उत्तरल्याशिवाय विश्वास ठेऊ नये अशी त्यांची शिकवणुक आहे.<br /><br />
                                आध्यात्मिक, आर्थिक, सामाजिक प्रगतीसाठी कोणतीही उपासना, करण्यापेक्षा आपण करीत असलेले काम शंभर टक्के (१००%) प्रामाणिकपणे करणे हीच खरी देवपूजा व आराधना होय असे ते छातीठोकपणे सागतात, कोणताही देव काहीही मागत नाही. देव हा फक्त देणेच जाणतो. तो आपल्या भक्तांना सदैव देतच असतो त्याच्यावर प्रेम करित असतो. देव हा फक्त भक्तीचा भुकेला असतो. आपल्या घरात येणारे धन, विचार आपले आचार, सात्विक, समाधानी असण्यासाठी प्रत्येक गोष्ठ भगवंताला अर्पण करणे हा विचार मनात सतत ठेवणे इतकीच पुजा हे ते आपल्या भक्तांना सांगतात.</p>
                        </div>

                    </div>
                    <div className="cardimage1">
                        <img src={firstimage}></img>
                    </div>
                </section>

                <section className="secondsection">
                    <div className="card2text">
                        <div className="cardimage2">
                            <img src={secondimage}></img>
                        </div>
                        <div className="subtext2">
                            <p>श्री. सद्गुरू अप्पामहाराज सांगतात जे काही पाहिजे असेल ते देण्यास श्री. दत्तमहाराज सदैव तत्पर असतात. परंतु त्यसाठी मनुष्याचे मन, शरीर व धन शुद्ध, पवित्र असणे आवश्यक आहे. त्यासाठी आपलेकडे असणारे दोष व्यसन सर्व देवाला अर्पण करून आपले शरीर, मन शुद्ध केल्यास मनुष्य जन्म प्राप्तः होतो. यावर त्यांचा विश्वास आहे. म्हणून आपल्य भक्तांना हीच शिकवण देतात त्यांच्या शिकवणुकीची जे पालन करतात त्या सर्वांचे जीवन सुखी झाले आहे अशी प्रचीती आली आहे. त्यमुळे त्यांचा भक्तगण उत्तोरोतर वाढतच चालला आहे. संपूर्ण भारतभर त्यांचे भक्तः वाढलेले आढळतात. परंतु आपली प्रासिद्धी व्हावी किवा करावी हे त्यांच्या तत्त्वात बसत नाही. त्यांना वाटत नाही . फक्त कार्यरत रहाणे येवढेच त्यांना माहित आहे. साखर गोड आहे हे कुणी सांगून समजत नाही. परंतु ती खाल्यावर गोड आहे आणि गोड म्हणजे काय हे ज्याचे त्याला फक्तसमजते यासाठी प्रमाण द्यावे लागत नाही. भक्तांना आप्पामहाराजाची प्रचीती आली आहे. त्यामुळे सर्वांचे जीवन सुखमय झाले आहे. कोणीतरी म्हणले आहे. हा "देहना माझा राहिला दत्त दिंगबर"<br /><br />
                                अशा या आमच्या सद्गुरूचा कृपाप्रसादाने व कृपाशीर्वादाने सर्व भक्त आपल्या जीवनात सुखी व समाधानी आहेत. सर्व दत्तभक्तांची मांदीयाळी आहे. सर्वांचा एक परिवार आहे. सर्व दत्तभक्त नियमीतपणे आपल्या सद्गुरूच्या दर्शनासाठी रुईभर येथे जात असतात व भक्तीची व आशीर्वादाची शिदोरी आणत असतात प्रलोभनाच्या महासागरात सर्व भक्तजनांच्याजीवनाचे कार्य भरकटू नये म्हणून सर्व भक्तगण नित्यनियमाने एकत्र येऊन भजन, कीर्तन, आरती सहोळा यासारखे उपक्रम राबुवून सर्वजण श्रेद्धेने सहभागी होत असतो.</p>
                        </div>

                    </div>

                </section>
            </div>
            <div className="mobile-container">
                {/* Hero Section */}
                <section className="firstsection">
                    <div className="card1text">
                        <div className="subtext">
                            <h1>बाबाजी...</h1>
                            <div className="cardimage1">
                                <img src={firstimage}></img>
                            </div>
                            <p>श्री सद्गुरू अप्पामहाराज व‬ श्री दत्त मंदिर संस्थान रुईभर

                                श्री सद्गुरू अप्पामहाराज उर्फ श्री दत्तमहाराज रुईकर, मु. पो. रुईभर, ता. धाराशिव, जि. उस्मानाबाद येथिल दत्तमंदिरात त्यांचे वास्तव्य असते. दत्त उपासना मार्गातील एक उपासना असुन व्यक्तीमत्व असुन त्यांची राहणी अतिशय साधी आहे. समाजातील सर्वसामान्य माणसाची काळजी वाहण्याचे व त्यांचे जीवन सुखी, सुसह्य व सार्थकी करण्यासाठी त्यांनी आपले स्वतःचे जीवन समर्पित केले आहे. अहोरात्र जनसामान्याच्या सुखासाठी, त्यांच्या समस्या सोडविण्यसाठी ते सतत प्रयत्नशिल असतात. अंधश्रद्धेवर त्यंचा विश्वास नाही. समाजात रूढ असलेल्या रूढी, परंपरा, मान्यता प्रथम विज्ञानाच्या नंतर धर्माच्या आणि सर्वात महत्त्वाच्या म्हणजे समाजाच्या कसोटीवर सत्य उत्तरल्याशिवाय विश्वास ठेऊ नये अशी त्यांची शिकवणुक आहे.<br /><br />
                                आध्यात्मिक, आर्थिक, सामाजिक प्रगतीसाठी कोणतीही उपासना, करण्यापेक्षा आपण करीत असलेले काम शंभर टक्के (१००%) प्रामाणिकपणे करणे हीच खरी देवपूजा व आराधना होय असे ते छातीठोकपणे सागतात, कोणताही देव काहीही मागत नाही. देव हा फक्त देणेच जाणतो. तो आपल्या भक्तांना सदैव देतच असतो त्याच्यावर प्रेम करित असतो. देव हा फक्त भक्तीचा भुकेला असतो. आपल्या घरात येणारे धन, विचार आपले आचार, सात्विक, समाधानी असण्यासाठी प्रत्येक गोष्ठ भगवंताला अर्पण करणे हा विचार मनात सतत ठेवणे इतकीच पुजा हे ते आपल्या भक्तांना सांगतात.</p>
                        </div>

                    </div>

                </section>

                <section className="secondsection">
                    <div className="card2text">
                        <div className="subtext2">
                            <div className="cardimage2">
                                <img src={secondimage}></img>
                            </div>
                            <p>श्री. सद्गुरू अप्पामहाराज सांगतात जे काही पाहिजे असेल ते देण्यास श्री. दत्तमहाराज सदैव तत्पर असतात. परंतु त्यसाठी मनुष्याचे मन, शरीर व धन शुद्ध, पवित्र असणे आवश्यक आहे. त्यासाठी आपलेकडे असणारे दोष व्यसन सर्व देवाला अर्पण करून आपले शरीर, मन शुद्ध केल्यास मनुष्य जन्म प्राप्तः होतो. यावर त्यांचा विश्वास आहे. म्हणून आपल्य भक्तांना हीच शिकवण देतात त्यांच्या शिकवणुकीची जे पालन करतात त्या सर्वांचे जीवन सुखी झाले आहे अशी प्रचीती आली आहे. त्यमुळे त्यांचा भक्तगण उत्तोरोतर वाढतच चालला आहे. संपूर्ण भारतभर त्यांचे भक्तः वाढलेले आढळतात. परंतु आपली प्रासिद्धी व्हावी किवा करावी हे त्यांच्या तत्त्वात बसत नाही. त्यांना वाटत नाही . फक्त कार्यरत रहाणे येवढेच त्यांना माहित आहे. साखर गोड आहे हे कुणी सांगून समजत नाही. परंतु ती खाल्यावर गोड आहे आणि गोड म्हणजे काय हे ज्याचे त्याला फक्तसमजते यासाठी प्रमाण द्यावे लागत नाही. भक्तांना आप्पामहाराजाची प्रचीती आली आहे. त्यामुळे सर्वांचे जीवन सुखमय झाले आहे. कोणीतरी म्हणले आहे. हा "देहना माझा राहिला दत्त दिंगबर"<br /><br />
                                अशा या आमच्या सद्गुरूचा कृपाप्रसादाने व कृपाशीर्वादाने सर्व भक्त आपल्या जीवनात सुखी व समाधानी आहेत. सर्व दत्तभक्तांची मांदीयाळी आहे. सर्वांचा एक परिवार आहे. सर्व दत्तभक्त नियमीतपणे आपल्या सद्गुरूच्या दर्शनासाठी रुईभर येथे जात असतात व भक्तीची व आशीर्वादाची शिदोरी आणत असतात प्रलोभनाच्या महासागरात सर्व भक्तजनांच्याजीवनाचे कार्य भरकटू नये म्हणून सर्व भक्तगण नित्यनियमाने एकत्र येऊन भजन, कीर्तन, आरती सहोळा यासारखे उपक्रम राबुवून सर्वजण श्रेद्धेने सहभागी होत असतो.</p>
                        </div>

                    </div>

                </section>
            </div>
            <div className="container2">
                <div className="firstsectioncontainer2">
                    <h2>Photo Gallery</h2>
                    <img src={"https://srikanipakadevasthanam.org/static/media/SD-divider.7a715d6c.svg"} alt="divider" />
                </div>

                {/* Image Gallery Section */}
                <div className="gallery-container">
                    <button className="arrow left" onClick={prevSlide}>&#10094;</button>

                    <div className={`image-grid ${isSliding ? "slide" : ""}`}>
                        {images.slice(startIndex, startIndex + 3).map((image, index) => (
                            <div key={index} className="image-card">
                                <img src={image} alt={`Gallery Image ${index + 1}`} />
                            </div>
                        ))}
                    </div>

                    <button className="arrow right" onClick={nextSlide}>&#10095;</button>
                </div>
                {/* <div className="viewallphoto">
            <button className="viewallphotobutton">View All Photos</button>
            </div> */}
            </div>
            <div className="mobile-container2">
                <div className="firstsectioncontainer2">
                    <h2>Photo Gallery</h2>
                    <img src={"https://srikanipakadevasthanam.org/static/media/SD-divider.7a715d6c.svg"} alt="divider" />
                </div>

                {/* Image Gallery Section */}
                <div className="gallery-container">
                    <button className="arrow left" onClick={mobileprevSlide}>&#10094;</button>

                    <div className={`image-grid ${mobileisSliding ? "slide" : ""}`}>
                        {images.slice(mobilestartIndex, mobilestartIndex + 1).map((image, index) => (
                            <div key={index} className="image-card">
                                <img src={image} alt={`Gallery Image ${index + 1}`} />
                            </div>
                        ))}
                    </div>

                    <button className="arrow right" onClick={mobilenextSlide}>&#10095;</button>
                </div>
                {/* <div className="viewallphoto">
            <button className="viewallphotobutton">View All Photos</button>
            </div> */}
            </div>


        </div>
    );
}
